export const sushi = {
  seo: {
    title: 'Cas client : De Wethouder Food & Drink Club | Bistroo',
    description: "Découvrez comment De Wethouder Food & Drink Club a trouvé un partenaire en ligne fiable avec Bistroo.",
  },
  hero: {
    title: 'Lisez comment De Wethouder a trouvé un partenaire en ligne fiable en Bistroo',
    description:
      'De Wethouder Food & Drink Club est un établissement tendance situé dans l\'ancien hôtel de ville de Denekamp. Ils proposent un menu varié et changeant, avec comme point fort le concept unique de walking diner.',
  },
  testimonials: {
    1: {
      text: '"Avec la solution de commande de Bistroo, nous avons pu traiter les commandes avec précision et gérer leur traitement. Cela a conduit à moins d\'erreurs et à une meilleure satisfaction client"',
      name: 'Ben Schulte',
      job_title: 'Chef',
    },
    2: {
      text: '"L\'utilisation de Bistroo pour la vente de sushi à emporter s\'est avérée particulièrement réussie et efficace, ce qui a contribué à un meilleur service et à une expérience client améliorée. Nous n\'aurions jamais su cela autrement !"',
      name: 'Edwin ter Haar',
      job_title: 'Responsable opérationnel',
    },
  },
  challenge: {
    paragraph: {
      title: 'Une collaboration durable',
      text: 'En plus de leur expérience dine-in, ils proposent également du sushi à emporter, une offre populaire vendue via Bistroo. De Wethouder collabore avec Bistroo depuis plus de 2 ans et raconte brièvement les défis qu\'ils avaient avant la collaboration et les solutions qu\'apporte Bistroo.',
    },
    paragraph_2: {
      title: 'Le défi',
      bullets: {
        1: 'Pendant les heures de pointe, De Wethouder Food & Drink Club était submergé par les commandes, ce qui surchargeait le personnel et obligeait les clients à attendre plus longtemps.',
        2: 'La gestion des commandes et de leur traitement était un défi, notamment pendant les périodes chargées.',
        3: 'Il était crucial de s\'assurer que les commandes soient traitées avec précision pour minimiser les erreurs et garantir la satisfaction des clients.',
      },
    },
  },
  solution: {
    title: 'La solution',
    checklist: {
      1: "Grâce à la solution de commande en ligne de Bistroo, De Wethouder Food & Drink Club pouvait gérer facilement et efficacement son offre de sushi à emporter. Les clients pouvaient facilement commander et retirer en ligne, ce qui rationalisait le processus.",
      2: "Avec la solution de commande de Bistroo, De Wethouder | Food & Drink Club pouvait traiter les commandes avec précision et gérer leur traitement. Cela a conduit à moins d'erreurs et à une meilleure satisfaction client.",
      3: 'Bistroo a offert à De Wethouder | Food & Drink Club flexibilité et adaptabilité, leur permettant de répondre rapidement aux besoins changeants et aux nouvelles opportunités, comme la vente de sushi à emporter.',
    },
  },
  conclusion: {
    title: 'Conclusion',
    text: {
      1: "Grâce à la solution de commande en ligne de Bistroo, De Wethouder Food & Drink Club a pu non seulement améliorer son efficacité opérationnelle, mais aussi augmenter la satisfaction de ses clients et exploiter les opportunités de croissance. L'utilisation de Bistroo pour la vente de sushi à emporter s'est avérée particulièrement réussie et efficace, contribuant à un meilleur service et à une expérience client améliorée. Bistroo se distingue par son hospitalité locale, en réfléchissant activement à des solutions et de nouvelles opportunités pour De Wethouder Food & Drink Club. Cette approche locale crée un lien de confiance solide et renforce la collaboration entre les deux parties.",
      2: 'De plus, Bistroo est disponible 24h/24 et 7j/7 pour soutenir De Wethouder Food & Drink Club, quel que soit le moment. Ce soutien continu donne au restaurant la tranquillité d\'esprit et la confiance dans leur processus de commande en ligne. De Wethouder | Food & Drink Club recommande vivement Bistroo à d\'autres entreprises de restauration qui recherchent une solution de commande en ligne flexible et efficace.',
    },
  },
}
